// extracted by mini-css-extract-plugin
export default {"addButton":"IntegrationScreen_addButton__TEI3N","titleAddButton":"IntegrationScreen_titleAddButton__D+jRL"};